/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { SubPeriodTypes } from "../models/sub-period-types";
@Injectable({
  providedIn: "root",
})
class SubPeriodTypesService extends __BaseService {
  static readonly subPeriodTypesGetSubPeriodTypesAllPath =
    "/api/admin/subscription/SubPeriodTypes";
  static readonly subPeriodTypesPostSubPeriodTypesPath =
    "/api/admin/subscription/SubPeriodTypes";
  static readonly subPeriodTypesGetSubPeriodTypesPath =
    "/api/admin/subscription/SubPeriodTypes/{id}";
  static readonly subPeriodTypesPutSubPeriodTypesPath =
    "/api/admin/subscription/SubPeriodTypes/{id}";
  static readonly subPeriodTypesDeleteSubPeriodTypesPath =
    "/api/admin/subscription/SubPeriodTypes/{id}";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  subPeriodTypesGetSubPeriodTypesAllResponse(): __Observable<
    __StrictHttpResponse<Array<SubPeriodTypes>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/admin/subscription/SubPeriodTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SubPeriodTypes>>;
      })
    );
  }
  subPeriodTypesGetSubPeriodTypesAll(): __Observable<Array<SubPeriodTypes>> {
    return this.subPeriodTypesGetSubPeriodTypesAllResponse().pipe(
      __map((_r) => _r.body as Array<SubPeriodTypes>)
    );
  }

  /**
   * @param subPeriodTypes undefined
   */
  subPeriodTypesPostSubPeriodTypesResponse(
    subPeriodTypes: SubPeriodTypes
  ): __Observable<__StrictHttpResponse<SubPeriodTypes>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = subPeriodTypes;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/admin/subscription/SubPeriodTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubPeriodTypes>;
      })
    );
  }
  /**
   * @param subPeriodTypes undefined
   */
  subPeriodTypesPostSubPeriodTypes(
    subPeriodTypes: SubPeriodTypes
  ): __Observable<SubPeriodTypes> {
    return this.subPeriodTypesPostSubPeriodTypesResponse(subPeriodTypes).pipe(
      __map((_r) => _r.body as SubPeriodTypes)
    );
  }

  /**
   * @param id undefined
   */
  subPeriodTypesGetSubPeriodTypesResponse(
    id: number
  ): __Observable<__StrictHttpResponse<SubPeriodTypes>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/admin/subscription/SubPeriodTypes/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubPeriodTypes>;
      })
    );
  }
  /**
   * @param id undefined
   */
  subPeriodTypesGetSubPeriodTypes(id: number): __Observable<SubPeriodTypes> {
    return this.subPeriodTypesGetSubPeriodTypesResponse(id).pipe(
      __map((_r) => _r.body as SubPeriodTypes)
    );
  }

  /**
   * @param params The `SubPeriodTypesService.SubPeriodTypesPutSubPeriodTypesParams` containing the following parameters:
   *
   * - `subPeriodTypes`:
   *
   * - `id`:
   */
  subPeriodTypesPutSubPeriodTypesResponse(
    params: SubPeriodTypesService.SubPeriodTypesPutSubPeriodTypesParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.subPeriodTypes;

    let req = new HttpRequest<any>(
      "PUT",
      this.rootUrl + `/api/admin/subscription/SubPeriodTypes/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SubPeriodTypesService.SubPeriodTypesPutSubPeriodTypesParams` containing the following parameters:
   *
   * - `subPeriodTypes`:
   *
   * - `id`:
   */
  subPeriodTypesPutSubPeriodTypes(
    params: SubPeriodTypesService.SubPeriodTypesPutSubPeriodTypesParams
  ): __Observable<Blob> {
    return this.subPeriodTypesPutSubPeriodTypesResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  subPeriodTypesDeleteSubPeriodTypesResponse(
    id: number
  ): __Observable<__StrictHttpResponse<SubPeriodTypes>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "DELETE",
      this.rootUrl + `/api/admin/subscription/SubPeriodTypes/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubPeriodTypes>;
      })
    );
  }
  /**
   * @param id undefined
   */
  subPeriodTypesDeleteSubPeriodTypes(id: number): __Observable<SubPeriodTypes> {
    return this.subPeriodTypesDeleteSubPeriodTypesResponse(id).pipe(
      __map((_r) => _r.body as SubPeriodTypes)
    );
  }
}

module SubPeriodTypesService {
  /**
   * Parameters for SubPeriodTypesPutSubPeriodTypes
   */
  export interface SubPeriodTypesPutSubPeriodTypesParams {
    subPeriodTypes: SubPeriodTypes;
    id: number;
  }
}

export { SubPeriodTypesService };
